// Live MLS licensing — single source of truth for which brokerage may receive
// ARMLS data. Imported by App.js and FunnelLanding.jsx. It lives here rather
// than in App.js because App.js imports FunnelLanding, so FunnelLanding could
// not import it back without a cycle — the same reason funnelReserved.js
// exists. Keep these in sync by importing — never duplicate the literal.
// The servers enforce their own rules; these helpers only decide what the
// screens show.

// 2026-10-26: My Wins covers both brokerages, each reading only its own
// office's wins (the read policies on listing_events and agent_cards, and
// the page's own office filter via current_armls_office()). Was HomePros
// (AJAA01) only. Keep this list in step with
// supabase/functions/_shared/armlsBrokerages.ts.
export const MY_WINS_BROKERAGES = ['HomePros', 'HomePros Advantage']

export function isMlsLicensed(profile) {
  return MY_WINS_BROKERAGES.includes(profile?.brokerage)
}

// 2026-10-24: live comps in the Strategist (comp pull, Analyze, strategy chat
// and report) cover both brokerages, each pulled with its own ARMLS key on the
// server (supabase/functions/_shared/armlsBrokerages.ts). Keep this list in
// step with that map.
export const LIVE_COMPS_BROKERAGES = ['HomePros', 'HomePros Advantage']

export function canUseLiveComps(profile) {
  return LIVE_COMPS_BROKERAGES.includes(profile?.brokerage)
}

// 2026-10-24: IDX listings display (IdxListings on agent pages and funnels)
// covers both brokerages, each read with its own ARMLS IDX key on the server
// (get-idx-listings). Display only; canUseLiveComps above decides the
// Strategist, and Market Snapshot stays a HomePros admin tool (App.js).
export const IDX_DISPLAY_BROKERAGES = ['HomePros', 'HomePros Advantage']

export function canShowIdxListings(profile) {
  return IDX_DISPLAY_BROKERAGES.includes(profile?.brokerage)
}
